import { render, staticRenderFns } from "./PreScreenedPatientsTrendingGraph.vue?vue&type=template&id=6972fe4c&"
import script from "./PreScreenedPatientsTrendingGraph.vue?vue&type=script&lang=js&"
export * from "./PreScreenedPatientsTrendingGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports